<template>
  <svg width="16" height="16" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="Icon Icon--check ">
    <path d="M3.33333 9.33333L6 11.3333L12 4" stroke="currentColor" stroke-width="1.5"></path>
  </svg>
</template>